import React from 'react';
import {
  Button, Typography, useTheme,
} from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

interface ListViewButtonProps {
  btnLabel: string;
  listViewId: string;
  optionalStyles?: React.CSSProperties;
  onBtnClick?: () => void;
}

export function ListViewButton({
  btnLabel, listViewId, optionalStyles, onBtnClick,
}: ListViewButtonProps) {
  const theme = useTheme();
  return (
    <Button
      data-testid={`${listViewId}-button`}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: theme.spacing(0.625),
        width: '100%',
        color: theme.palette.brand.primary,
        backgroundColor: 'transparent',
        '&:hover': {
          cursor: 'pointer',
          backgroundColor: 'transparent',
        },
        ...optionalStyles,
      }}
      onClick={onBtnClick}
    >
      <Typography
        variant='h15'
        sx={{
          lineHeight: theme.spacing(3),
          [theme.breakpoints.down('sm')]: {
            fontSize: theme.spacing(1.75),
          },
        }}
      >
        {btnLabel}
      </Typography>
      <ArrowForwardIcon />
    </Button>
  );
}
